import {forEach, isEmpty, isUndefined} from 'lodash'
import * as z from 'zod/mini'
import type {ExtendedFuel} from '../../constants/fuels'
import {FUEL_ELEKTRO} from '../../constants/fuels'
import type {LegalForm} from '../../constants/legalFormTypes'
import {PRIVATE_PERSON} from '../../constants/legalFormTypes'
import * as unionV2Discounts from '../../constants/unionV2/discounts'
import type {VehicleType} from '../../constants/vehicleTypes'
import {VEHICLE_TYPE_SCOOTER} from '../../constants/vehicleTypes'
import {registrationDateIsValid} from '../utils'
import {validateBornNumber} from './validations'


export const bornNumberMatchesBirthday = (
  {legalForm, birthday, bornNumber}: {
    legalForm: LegalForm,
    birthday?: string,
    bornNumber?: string,
  },
  ctx: z.core.$RefinementCtx,
) => {
  const bornNumberError = validateBornNumber(legalForm, birthday, bornNumber)
  if (bornNumberError) {
    ctx.addIssue({
      code: 'custom',
      path: ['bornNumber'],
      message: bornNumberError,
    })
  }
  return z.NEVER
}

export const holderBornNumberMatchesBirthday = (
  {holderLegalForm, holderBirthday, holderBornNumber}: {
    holderLegalForm: LegalForm,
    holderBirthday?: string,
    holderBornNumber?: string
  },
  ctx: z.core.$RefinementCtx,
) => {
  const bornNumberError = validateBornNumber(holderLegalForm, holderBirthday, holderBornNumber)
  if (bornNumberError) {
    ctx.addIssue({
      code: 'custom',
      path: ['holderBornNumber'],
      message: bornNumberError,
    })
  }
  return z.NEVER
}


export const ownerBornNumberMatchesBirthday = (
  {ownerLegalForm, ownerBirthday, ownerBornNumber}: {
    ownerLegalForm: LegalForm,
    ownerBirthday?: string,
    ownerBornNumber?: string
  },
  ctx: z.core.$RefinementCtx,
) => {
  const bornNumberError = validateBornNumber(ownerLegalForm, ownerBirthday, ownerBornNumber)
  if (bornNumberError) {
    ctx.addIssue({
      code: 'custom',
      path: ['ownerBornNumber'],
      message: bornNumberError,
    })
  }
  return z.NEVER
}

export const volumeForNonElectroFuel = (
  {fuel, volume}: {
    fuel: ExtendedFuel,
    volume?: number,
  },
  ctx: z.core.$RefinementCtx,
) => {
  if (fuel !== FUEL_ELEKTRO && !isUndefined(volume) && volume < 1) {
    ctx.addIssue({
      code: 'custom',
      path: ['volume'],
      message: 'Objem motora musí byť väčší ako 1.',
    })
  }
  return z.NEVER
}

export const licensePlateOrVin = (
  {vehicleType, licensePlate, vin}: {
    vehicleType: VehicleType,
    licensePlate?: string,
    vin?: string,
  },
  ctx: z.core.$RefinementCtx,
) => {
  if (vehicleType !== VEHICLE_TYPE_SCOOTER && !licensePlate && !vin) {
    forEach(['licensePlate', 'vin'], (field) => {
      ctx.addIssue({
        code: 'custom',
        path: [field],
        message: 'Musí byť vyplnené ŠPZ alebo VIN',
      })
    })
  }
  return z.NEVER
}

export const conditionalOdometer = (
  {vehicleType, legalForm, odometer}: {
    vehicleType: VehicleType,
    legalForm: LegalForm,
    odometer?: number,
  },
  ctx: z.core.$RefinementCtx,
) => {
  if (vehicleType !== VEHICLE_TYPE_SCOOTER && legalForm === PRIVATE_PERSON && !odometer) {
    ctx.addIssue({
      code: 'custom',
      path: ['odometer'],
      message: 'Povinné',
    })
  }
  return z.NEVER
}

export const checkRegistrationDate = (
  {productionYear, registrationDate}: {
    productionYear: number,
    registrationDate?: string,
  },
  ctx: z.core.$RefinementCtx,
) => {
  if (registrationDate && !registrationDateIsValid(registrationDate, productionYear)) {
    ctx.addIssue({
      code: 'custom',
      path: ['registrationDate'],
      message: 'Rok registrácie nesmie byť nižší ako rok výroby vozdila.',
    })
  }
  return z.NEVER
}

export const unionUzpDiscount = (
  {uzpDiscount, bornNumber, uzpApplication}: {
    uzpDiscount?: unionV2Discounts.Discount,
    bornNumber?: string,
    uzpApplication?: string,
  },
  ctx: z.core.$RefinementCtx,
) => {
  if (uzpDiscount === unionV2Discounts.DISCOUNT_UZP && isEmpty(bornNumber)) {
    ctx.addIssue({
      code: 'custom',
      path: ['bornNumber'],
      message: 'Rodné číslo je povinné pre uplatnenie zľavy UZP.',
    })
  }
  if (uzpDiscount === unionV2Discounts.DISCOUNT_UZP_APPLICATION && isEmpty(uzpApplication)) {
    ctx.addIssue({
      code: 'custom',
      path: ['uzpApplication'],
      message: 'Číslo podanej prihlášky je povinné pre uplatnenie zľavy UZP.',
    })
  }
  return z.NEVER
}
